import styled from 'styled-components'
import TextField from '@material-ui/core/TextField';

export const Form = styled.form``

export const Input = styled(TextField)`
    width: 300px;
`